module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "map"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list[0]),
      expression: "list[0]"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("测试内容1")]), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list[1]),
      expression: "list[1]"
    }],
    staticClass: "item2"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("测试内容222")]), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list[2]),
      expression: "list[2]"
    }],
    staticClass: "item3"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("测试内容333")]), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })])]), _vm._v(" "), _c('v-table1'), _vm._v(" "), _c('v-table2')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a6034c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/tourupin/components/center/index.vue
// module id = 1931
// module chunks = 2